/* eslint-disable no-console */
import React, {useEffect, useState} from 'react';
import {useSearchParams} from 'react-router-dom';

import BlockAccessPage from '../../../../components/BlockAccess/BlockAccessPage';
import OrgChartComponent from '../../../../components/Chart/OrgChart/OrgChartComponent';
import Loader from '../../../../components/Loader/Loader';
import PageContent from '../../../../components/PageContent/PageContent';
import orgHierarchyandProcessFlowAPI from '../../../../services/modules/Configurator/orgHierarchyandProcessFlowAPI';
// import {yearSelect} from '../../../../utils/FormUtils/yearSelect';
import {accessModule} from '../../../../store/companyStore/companyDetailsStore';
import {checkCurrentYearOrBelow} from '../../../../utils/commonFunctions';
import {shouldBlockModuleAccess} from '../../../../utils/SubscriptionHelper';
import {ChartType} from '../constants/Constants';

const ProcessFlow: React.FC = () => {
  const [mainData, setMainData] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedYear, setSelectedYear] = useState('');
  const [searchParam, setSearchParams] = useSearchParams();
  // const firstYear = yearSelect();

  useEffect(() => {
    const currentYear = checkCurrentYearOrBelow(
      searchParam.get('selectedYear')
    );
    setSelectedYear(currentYear);
    searchParam.set('selectedYear', currentYear);
    setSearchParams(searchParam);
  }, []);

  useEffect(() => {
    if (selectedYear) {
      setIsLoading(true);
      orgHierarchyandProcessFlowAPI(selectedYear, ChartType.processFlow)
        .then((res) => {
          setMainData(res ?? []);
        })
        .catch(() => {})
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [selectedYear]);

  return (
    <PageContent>
      {isLoading ? (
        <Loader />
      ) : (
        <div style={{height: '100%'}}>
          {shouldBlockModuleAccess(accessModule.processFlow) ? (
            <BlockAccessPage />
          ) : (
            <OrgChartComponent
              data={mainData}
              isHorizontal={false}
              chartType={ChartType.processFlow}
              setSelectedYear={setSelectedYear}
            />
          )}
        </div>
      )}
    </PageContent>
  );
};

export default ProcessFlow;
